import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "../../store/app.reducer";
import { toObservable } from "@angular/core/rxjs-interop";
import { filter, skipWhile, switchMap, take } from "rxjs";
import { GDPRConsentService } from "./gdpr-consent.service";
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";
import { CheckboxModule } from "primeng/checkbox";
import { FormsModule } from "@angular/forms";
import { RouterLink } from "@angular/router";

@Component({
  selector: "app-gdpr-consent-dialog",
  imports: [DialogModule, ButtonModule, CheckboxModule, FormsModule, RouterLink],
  templateUrl: "./gdpr-consent-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GDPRConsentDialogComponent {
  private store = inject(Store<AppState>);
  private gdprService = inject(GDPRConsentService);
  private authState$ = toObservable(this.store.selectSignal((state) => state.auth));

  protected visible = signal(false);
  protected dataProcessing = signal(false);
  protected notifications = signal(false);
  protected submitting = signal(false);
  protected error = signal<string | null>(null);

  constructor() {
    // After login, check if GDPR consent is needed
    this.authState$
      .pipe(
        skipWhile((state) => !state.autoLoginAttempted),
        take(1),
        filter((state) => !!state.user),
        switchMap(() => this.gdprService.getConsentStatus())
      )
      .subscribe({
        next: (status) => {
          if (status.needs_consent) {
            this.dataProcessing.set(status.gdpr_data_processing);
            this.notifications.set(status.gdpr_notifications);
            this.visible.set(true);
          }
        },
        error: () => {
          // Silently fail - don't block the user
        },
      });
  }

  submit() {
    if (!this.dataProcessing()) {
      this.error.set("Trebuie să acceptați prelucrarea datelor pentru a utiliza platforma.");
      return;
    }

    this.error.set(null);
    this.submitting.set(true);
    this.gdprService
      .submitConsent({
        gdpr_data_processing: this.dataProcessing(),
        gdpr_notifications: this.notifications(),
      })
      .subscribe({
        next: () => {
          this.visible.set(false);
          this.submitting.set(false);
        },
        error: () => {
          this.error.set("A apărut o eroare. Încercați din nou.");
          this.submitting.set(false);
        },
      });
  }
}
